export const getOnetimePasscodeMessages = () => {
    const ONE_TIME_PASSCODE = {
        VERIFY_TITLE: [
            { message: 'Security verification', language: 'English' },
            { message: 'セキュリティ認証', language: 'Japanese' },
            { message: '安全性驗證', language: 'Traditional' },
            { message: '安全性验证', language: 'Simplified' },
        ],
        INPUT_LABLE_VERIFY_CODE: [
            { message: 'Email Verification Code', language: 'English' },
            { message: 'Eメール認証コード', language: 'Japanese' },
            { message: 'Email驗證碼', language: 'Traditional' },
            { message: 'Email验证码', language: 'Simplified' },
        ],
        GET_CODE: [
            { message: 'Get Code', language: 'English' },
            { message: 'コード取得', language: 'Japanese' },
            { message: '取得驗證碼', language: 'Traditional' },
            { message: '取得验证码', language: 'Simplified' },
        ],
        REGET_CODE: [
            { message: 'Resent Code', language: 'English' },
            { message: 'コード再送信', language: 'Japanese' },
            { message: '重送驗證碼', language: 'Traditional' },
            { message: '重送验证码', language: 'Simplified' },
        ],
        BTN_SUBMIT: [
            { message: 'Verify', language: 'English' },
            { message: '認証する', language: 'Japanese' },
            { message: '驗證', language: 'Traditional' },
            { message: '验证', language: 'Simplified' },
        ],
    };
    const ONE_TIME_PASSCODE_ERROR = {
        NEED_GET_CODE: [
            { message: 'Please get Verify code', language: 'English' },
            { message: '認証コードを取得してください', language: 'Japanese' },
            { message: '請取得驗證碼', language: 'Traditional' },
            { message: '请取得验证码', language: 'Simplified' },
        ],
        REQUIRED_VERIFY_CODE: [
            { message: 'Required Verify code', language: 'English' },
            { message: '認証コードは必須です', language: 'Japanese' },
            { message: '驗證碼為必填', language: 'Traditional' },
            { message: '验证码为必填', language: 'Simplified' },
        ],
    };
    return {
        ONE_TIME_PASSCODE,
        ONE_TIME_PASSCODE_ERROR,
    };
};
